import { Component, Input, AfterViewInit, OnInit } from '@angular/core';
import { ArgyleIncomeStream } from 'src/app/models/Argyle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-1099-upload',
  templateUrl: './1099-upload.component.html',
  styleUrls: ['./1099-upload.component.less']
})
export class Upload1099Component implements AfterViewInit, OnInit {
  @Input() stream: ArgyleIncomeStream;
  overlays: any[];
  urlToUse: SafeUrl;
  loading: boolean = false;
  constructor(public modalService: NgbModal, public fileDownload: FileDownloadService, private toast: ToastrService, private auth: AuthService, public appData: ApplicantDataService, private sanitizer: DomSanitizer, private http: HttpClient, public groups: GroupApplicantsService) { }

  ngOnInit(): void {
    console.log('1099 STREAM', this.stream);
  }

  ngAfterViewInit(): void {
    // Optional: Logic for overlays if 1099s ever have them
  }

  // Helper methods for safe data access
  getPayerName(): string {
    try {
      return this.stream?.historicalData?.[0]?.metadata?.ocr_data?.forms?.[0]?.raw_fields?.['a_1099-nec-Part1-PayerPii:payerName']?.value || '-';
    } catch {
      return '-';
    }
  }

  getRecipientName(): string {
    try {
      return this.stream?.historicalData?.[0]?.metadata?.ocr_data?.forms?.[0]?.raw_fields?.['a_1099-nec-Part2-RecipientPii:recipientName']?.value || '-';
    } catch {
      return '-';
    }
  }

  getTaxYear(): string {
    try {
      return this.stream?.historicalData?.[0]?.metadata?.ocr_data?.forms?.[0]?.raw_fields?.['a_1099-nec-General:forCalendarYear']?.value || '-';
    } catch {
      return '-';
    }
  }

  getNonEmployeeCompensation(): string {
    try {
      const value = this.stream?.historicalData?.[0]?.metadata?.ocr_data?.forms?.[0]?.raw_fields?.['a_1099-nec-Part3-LocalInfo:(box1)NonemployeeCompensation']?.value;
      return value ? parseFloat(value).toFixed(2) : '-';
    } catch {
      return '-';
    }
  }

  getAuthenticityScore(): number {
    try {
      return this.stream?.historicalData?.[0]?.metadata?.ocr_authenticity_score || 0;
    } catch {
      return 0;
    }
  }

  getMonthlyGross(): string {
    try {
      const monthly = this.stream?.summary?.monthlyGrossAverage;
      return monthly ? monthly.toFixed(2) : '-';
    } catch {
      return '-';
    }
  }

  clearReport() {
    this.urlToUse = null;
  }

  setOverlay(recordId: number, index: number) {
    this.loading = true;
    this.urlToUse = null;
    this.http.get(`${environment.baseURl}/api/incomever/overlay/${recordId}/${index}`, { responseType: 'blob' })
      .subscribe(blob => {
        const url = URL.createObjectURL(blob);
        this.urlToUse = this.sanitizer.bypassSecurityTrustUrl(url);
        this.loading = false;
      });
  }

  download(i: any, docType) {
    this.appData.DownloadArgyleDoc(i.id, i.file_name , this.stream.inviteId, docType ).subscribe(res => {
      this.fileDownload.HandleFileDownload(res, 'pdf', i.file_name);
    })
  }
}
